import { render, staticRenderFns } from "./liveDraw.vue?vue&type=template&id=6c3a84e5&scoped=true&"
import script from "./liveDraw.vue?vue&type=script&lang=js&"
export * from "./liveDraw.vue?vue&type=script&lang=js&"
import style0 from "./liveDraw.vue?vue&type=style&index=0&id=6c3a84e5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3a84e5",
  null
  
)

export default component.exports